var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPychamLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 5.32672L33.7734 13.6L30.1467 20.8534L24.2534 19.2667H19.04L23.8 5.32672Z",
    fill: "url(#paint0_linear_101_107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8267 10.7667L11.9 20.8533L11.6733 24.3667L6.91332 26.52L0 27.2L2.04 5.21332L14.5067 0L22.2133 4.98668L13.8267 10.7667Z",
    fill: "url(#paint1_linear_101_107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8267 10.7667L14.7333 30.3734L11.6733 34L0 27.2L9.52 12.92L13.8267 10.7667Z",
    fill: "url(#paint2_linear_101_107)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6333 9.29332H14.8466L25.2733 0L26.6333 9.29332Z",
    fill: "url(#paint3_linear_101_107)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30.3733L23.5734 33.8867L9.85999 30.0333L13.8267 10.7667L15.4134 9.29332L23.8 8.5L23.12 17L29.8067 14.3933L34 30.3733Z",
    fill: "url(#paint4_linear_101_107)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 6.8H6.79999V27.2H27.2V6.8Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29333 9.29332H12.41C14.2233 9.29332 15.3567 10.37 15.3567 11.9566C15.3567 13.7133 13.9967 14.62 12.24 14.62H10.9367V16.8866H9.23669V9.29332H9.29333ZM12.2967 13.2033C13.1467 13.2033 13.6 12.6366 13.6 12.0133C13.6 11.2766 13.09 10.88 12.24 10.88H10.9367V13.2033H12.2967Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.32 13.1466C16.32 10.9933 17.9067 9.17995 20.2867 9.17995C21.76 9.17995 22.5534 9.63326 23.3467 10.3133L22.3267 11.5599C21.76 10.9933 21.1934 10.6533 20.4 10.6533C19.1534 10.6533 18.1334 11.6733 18.1334 13.0333C18.1334 14.3933 19.04 15.4133 20.4 15.4133C21.3067 15.4133 21.76 15.0733 22.44 14.5066L23.46 15.6399C22.5534 16.5466 21.6467 16.9999 20.1734 16.9999C17.9067 16.9999 16.32 15.2999 16.32 13.1466Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7167 23.63H9.06671V24.9333H16.7167V23.63Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_107",
    x1: 12.1424,
    y1: 13.1366,
    x2: 32.3758,
    y2: 13.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_107",
    x1: -11.9287,
    y1: 28.6965,
    x2: 29.7354,
    y2: -2.05991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#FCF84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#A7EB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#5FE077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#32DA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#20D68C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#1ED497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#19D1A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#13CCC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#0BC6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_107",
    x1: 4.53172,
    y1: 37.7177,
    x2: 11.4808,
    y2: 15.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#24D888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#2FD985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#41DC80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#5AE079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.673,
    stopColor: "#7AE46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#A1EA64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#CFF157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF84A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_107",
    x1: 13.7336,
    y1: 18.7597,
    x2: 28.8558,
    y2: -1.57177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#23D986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#2ADE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#36E669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#3BEA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#47EB61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#67ED5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#9AF156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#E0F64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF84A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_101_107",
    x1: 36.8604,
    y1: 21.3471,
    x2: 6.39101,
    y2: 21.0649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#FCF84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#ECF74C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#C1F451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#7EEF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BEA62"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPychamLogo);
export default __webpack_public_path__ + "static/media/pycham-logo.cb327968677e1de31a165b4b1a70f3cf.svg";
export { ForwardRef as ReactComponent };